import { Injectable } from '@angular/core';
import { DownloadWaitDialogComponent } from '../app/dialogs/download-wait-dialog/download-wait-dialog.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

@Injectable({
  providedIn: 'root'
})
export class DownloadIndicatorService {
  dialogRef!: DynamicDialogRef<DownloadWaitDialogComponent> | null;

  constructor(public dialogService: DialogService) { }

  openDialog() {
    // closable = true would fix bug with dynamic dialogs ( Maximum call stack size exceeded)
    // but since it does not make problems ( atm? ) ...
    this.dialogRef = this.dialogService.open(DownloadWaitDialogComponent, { appendTo: "body", modal: true,showHeader:false});
  }

  closeDialog() {
    if (this.dialogRef)
      this.dialogRef.close();
  }

}
